import React from 'react';
import './page-container.scss';

interface PageContainerProps {
    className?: string;
}

const PageContainer: React.FC<PageContainerProps> = (props) => {
    const {children, className} = props;

    return <div className={`pageContainer ${className || ''}`}>{children}</div>;
};

export default PageContainer;
